import { render, staticRenderFns } from "./project-notifications-filter.vue?vue&type=template&id=50a039e6&scoped=true"
import script from "./project-notifications-filter.vue?vue&type=script&lang=js"
export * from "./project-notifications-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a039e6",
  null
  
)

export default component.exports